var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prize"},[_c('router-link',{attrs:{"to":_vm.advertisingInfo.href || ''}},[_c('img',{attrs:{"src":_vm.advertisingInfo.img}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }